import React, { useEffect, useState } from 'react'

function DeleteTitle(props) {
  const [getDeleteTitle, setDeleteTitle] = useState({ TitleId: null, Title: '', Description: '' });

  useEffect(() => {
    setDeleteTitle(props.TitleData);
  }, [props.TitleData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Title will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Title :</b> {getDeleteTitle.Title}</li>
            <li><b>Description : </b>{getDeleteTitle.Description}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteTitleDetails" hidden>{JSON.stringify(getDeleteTitle)}</div>
    </>
  )
}

export default DeleteTitle